module.exports = __webpack_public_path__ + "img/7.8f59aeb6.png";